import environments from '@utils/environments';
import { Result } from '@utils/index';
import mixpanel, { Callback, RequestOptions } from 'mixpanel-browser';
import { MixpanelEvents, CustomProperties } from './types';

export function track(
  event_name: MixpanelEvents,
  properties?: Partial<CustomProperties>,
  optionsOrCallback?: RequestOptions | Callback,
  callback?: Callback,
) {
  if (environments.isLocal() || environments.isDev()) {
    console.groupCollapsed(`Mixpanel.track::${event_name}`);
    console.log('Properties:', properties);
    console.groupEnd();
  }

  const result = Result.optionalCatch<Error>(() => {
    mixpanel.track(event_name, properties, optionsOrCallback, response => {
      const now = new Date().toJSON();

      const isSuccessObject =
        typeof response === 'object' && response.status === 1;
      const isSuccessNum = typeof response === 'number' && response === 1;

      if (isSuccessObject || isSuccessNum) {
        mixpanel.people.set({ 'Last Event': now });
      }

      if (callback) callback(response);
    });
  });
  return result;
}
